import { createFileRoute } from "@tanstack/react-router";

import { ValidationReport } from "@/features/publisher";

export const Route = createFileRoute("/publisher/validation")({
  component: ValidationReport,
});
